import "./styles.scss";

import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import CategoriesContent from "../Content";

const Mobile = ({ isOpen = true, isContactOpen }) => {
  useEffect(() => {
    document.body.classList.add("mobile-menu--open");

    return () => document.body.classList.remove("mobile-menu--open");
  }, []);

  return (
    <AnimatePresence>
      <motion.div
        className="mobile-category"
        initial={{ opacity: 1, clipPath: "circle(0% at 100% 0%)" }}
        animate={{ opacity: 1, clipPath: "circle(150% at 100% 0%)" }}
        exit={{ opacity: 0, clipPath: "circle(150% at 100% 0%)" }}
        transition={{
          opacity: {
            type: "tween",
            duration: 0.3,
          },
          clipPath: {
            type: "tween",
            ease: "easeInOut",
            duration: 0.5,
          },
        }}
      >
        <div className="mobile-category__body">
          <AnimatePresence exitBeforeEnter initial={false}>
            <motion.div
              className="mobile-category__body-inner"
              initial={{ opacity: 0, height: "25%" }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: "25%" }}
              transition={{
                type: "tween",
                ease: "easeInOut",
                duration: 0.4,
              }}
            >
              <AnimatePresence exitBeforeEnter>
                <motion.div
                  className="blog-main__filters__categories__actions-dropdown-inner"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ type: "tween", duration: 0.3 }}
                  // onAnimationStart={(definition) => {
                  //   if (definition.opacity === 1) handleDropdownHeight();
                  // }}
                >
                  <CategoriesContent title="Która kategoria wpisów Cię interesuje?" />
                </motion.div>
              </AnimatePresence>
              {/* {getSubmenu(submenu)} */}
            </motion.div>
          </AnimatePresence>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Mobile;
